import './App.css';

import {Routes, Route} from 'react-router-dom'
import HomePage from './components/homeFiles/Home'
import HomeRedirectHandler from './components/homeFiles/HomeRedirectHandler';
import EducationPage from './components/educationFiles/Education';
import ExperiencePage from './components/experienceFiles/Experience';
import LeadershipPage from './components/leadershipFiles/Leadership';
import ProjectsPage from './components/projectsFiles/Projects';
import SkillsPage from './components/skillsFiles/Skills';

function App() {
  return (
    <>
      <div className="App">
        <Routes>
          <Route path='/' element={<HomePage />}></Route>
          <Route path='/Home' element={<HomeRedirectHandler />}></Route>
          <Route path='/Education' element={<EducationPage/>}></Route>
          <Route path='/Leadership' element={<LeadershipPage/>}></Route>
          <Route path='/Experience' element={<ExperiencePage/>}></Route>
          <Route path='/Projects' element={<ProjectsPage/>}></Route>
          <Route path='/Skills' element={<SkillsPage/>}></Route>
        </Routes>
      </div>
    </>
  );
}

export default App;
